<div class="form-container">
  <business-address-country-input (countrySelected)="countryChanged($event)"></business-address-country-input>
  <ng-container *ngIf="serviceAreaForm && serviceAreaToggle">
    <glxy-checkbox
      class="service-area"
      (click)="updateServiceArea($event.target.checked)"
      [formControl]="serviceAreaToggle"
    >
      {{ 'FRONTEND.BUSINESSES.SERVICE_AREA_BUSINESS' | translate }}
    </glxy-checkbox>
    <div class="service-area-hint">
      <glxy-hint [matTooltip]="'FRONTEND.BUSINESSES.SERVICE_AREA_BUSINESS_HINT' | translate">
        <a (click)="(null)" class="link">
          {{ 'FRONTEND.FORMS.INPUT.WHATS_THIS' | translate }}
        </a>
      </glxy-hint>
    </div>
    <mat-expansion-panel class="mat-elevation-z0" hideToggle [expanded]="serviceAreaForm.enabled">
      <glxy-form-field bottomSpacing="none">
        <mat-radio-group
          (change)="markServiceAreaDirty()"
          [formControl]="serviceAreaForm.get('businessType')"
          #businessType
        >
          <!--
            for some weird reason, the serviceAreaForm are not updated when calling the loadFormValues() method in the business profile. it still
            shows the initial value. I had to use the checked attribute to set the value of the radio button.
          -->
          <mat-radio-button [checked]="serviceAreaForm.get('businessType').value === 1" [value]="1">
            {{ 'FRONTEND.BUSINESSES.CUSTOMER_LOCATION_ONLY' | translate }}
          </mat-radio-button>
          <mat-radio-button [checked]="serviceAreaForm.get('businessType').value === 2" [value]="2">
            {{ 'FRONTEND.BUSINESSES.CUSTOMER_AND_BUSINESS_LOCATION' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </glxy-form-field>

      <glxy-form-field required="true" bottomSpacing="none">
        <glxy-label>{{ 'FRONTEND.BUSINESSES.SERVICE_AREAS' | translate }}</glxy-label>
        <business-place-autocomplete
          *ngIf="__addressData"
          [editDisabled]="editDisabled"
          (selected)="addPlace($event)"
          [geoLocation]="__addressData.location"
        ></business-place-autocomplete>
        <glxy-hint
          align="end"
          [style.color]="serviceAreaForm.get('places')?.value?.length > 0 ? 'rgba(0, 0, 0, 0.6)' : '#c62828'"
        >
          {{ serviceAreaForm.get('places')?.value?.length }}/20
        </glxy-hint>
        <glxy-error *ngIf="serviceAreaForm.get('places')?.value?.length < 1">
          {{ 'FRONTEND.BUSINESSES.SERVICE_AREAS_ERROR' | translate }}
        </glxy-error>
      </glxy-form-field>
      <mat-chip-listbox>
        <mat-chip-option
          (removed)="removePlace(place.placeId)"
          *ngFor="let place of serviceAreaForm.get('places')?.value"
        >
          {{ place.placeName }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-option>
      </mat-chip-listbox>
    </mat-expansion-panel>
  </ng-container>
  <form class="country-form-container" #form [formGroup]="formGroup" *ngIf="formFields">
    <div *ngFor="let field of formFields; let last = last" class="form-row">
      <!-- General text input -->
      <glxy-form-field
        *ngIf="dynamicControls.indexOf(field.key) > -1"
        bottomSpacing="small"
        class="address-form-field-{{ field.key }}"
      >
        <glxy-label>
          {{ (field.key === 'address2' ? 'FRONTEND.BUSINESSES.ADDRESS_FORM.ADDRESS_2' : field.label) | translate }}
        </glxy-label>
        <input matInput [required]="field.required" [formControlName]="field.key" />
        <glxy-error
          *ngIf="
            formGroup.controls[field.key].hasError('required') || formGroup.controls[field.key].hasError('whitespace')
          "
        >
          {{ 'FRONTEND.BUSINESSES.ADDRESS_FORM.REQUIRED_FIELD' | translate }}
        </glxy-error>
        <glxy-error *ngIf="formGroup.controls[field.key].hasError('invalidPostalCode')">
          {{ 'FRONTEND.BUSINESSES.ADDRESS_FORM.INVALID' | translate }} {{ field.label }}
        </glxy-error>
      </glxy-form-field>

      <!-- Dropdown with autocomplete -->
      <glxy-form-field
        *ngIf="field.key === 'province'"
        class="address-form-field-{{ field.key }}"
        suffixIcon="arrow_drop_down"
        [required]="true"
      >
        <glxy-label>{{ field.label }}</glxy-label>
        <input
          [formControlName]="field.key"
          [required]="field.required"
          [matAutocomplete]="provinceAutocomplete"
          autocomplete="doNotAutoComplete"
          [value]="field?.name"
          #provinceInput
        />
        <mat-autocomplete
          [autoActiveFirstOption]="provinceInput.value"
          #provinceAutocomplete="matAutocomplete"
          [displayWith]="provinceName"
        >
          <mat-option *ngFor="let option of provinces | filterProvinces: provinceInput.value" [value]="option">
            {{ option.name }}
          </mat-option>
        </mat-autocomplete>
        <glxy-error
          *ngIf="
            formGroup.controls[field.key].hasError('required') || formGroup.controls[field.key].hasError('whitespace')
          "
        >
          {{ 'FRONTEND.BUSINESSES.ADDRESS_FORM.REQUIRED_FIELD' | translate }}
        </glxy-error>
        <glxy-error *ngIf="formGroup.controls[field.key].hasError('invalidPostalCode')">
          {{ 'FRONTEND.BUSINESSES.ADDRESS_FORM.INVALID' | translate }} {{ field.label }}
        </glxy-error>
        <glxy-error *ngIf="formGroup.controls[field.key].hasError('invalidSelection')">
          {{ 'FRONTEND.BUSINESSES.ADDRESS_FORM.INVALID_SELECTION' | translate }}
        </glxy-error>
      </glxy-form-field>
    </div>
  </form>
</div>

<div class="address-output" *ngIf="showAddressPreview && formGroup.value | businessAddressPipe | async as address">
  <span class="preview-text">
    {{ 'FRONTEND.BUSINESSES.ADDRESS_FORM.PREVIEW' | translate }}
  </span>
  <span class="formatted-address">{{ address }}</span>
</div>
